import xhr from '../utils/fetch';

const add = async (enquiry: any) => {
  return await xhr({
    url: `/enquiries`,
    method: 'POST',
    body: enquiry
  }).then((res) => res);
};

const enquiryApi = {
  add
};

export default enquiryApi;
